import { render } from "./Rebot.vue?vue&type=template&id=d89879e0&scoped=true"
import script from "./Rebot.vue?vue&type=script&lang=js"
export * from "./Rebot.vue?vue&type=script&lang=js"

import "./Rebot.vue?vue&type=style&index=0&id=d89879e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89879e0"]])

export default __exports__